import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import ViewModuleIcon from 'material-ui/svg-icons/action/view-module';
import ArrowDownward from 'material-ui/svg-icons/navigation/arrow-downward';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import IconButton from 'material-ui/IconButton';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import Subheader from 'material-ui/Subheader';
import * as Colors from 'material-ui/styles/colors';
import {
  SORT_DIRECTION_ASC,
  SORT_DIRECTION_DESC,
} from '../consts';
import {
  changeSortDirection,
  changeSortField,
} from 'MyAccount/ViewDesigns/redux/modules/images';


@connect(
  (state, props) => ({
    sort: state.images[props.resourceType].sort,
  }),
  { changeSortDirection, changeSortField },
)
export default class SortBlock extends Component {
  getStyle(height, paddingTop) {
    return {
      sortBlock: {
        position: 'absolute',
        top: -paddingTop + 2,
        right: 60,
        zIndex: 3,
      }
    };
  }

  _changeSortDirection = () => {
    const { changeSortDirection, sort: { direction = '' }, resourceType } = this.props;
    switch (direction) {
      case SORT_DIRECTION_DESC:
        changeSortDirection({ direction: SORT_DIRECTION_ASC, resourceType });
        break;
      case SORT_DIRECTION_ASC:
        changeSortDirection({ direction: SORT_DIRECTION_DESC, resourceType });
        break;
      default:
        changeSortDirection({ direction: SORT_DIRECTION_ASC, resourceType });
    }
  };

  _changeSortField = (item, index, field) => {
    const { changeSortField, resourceType } = this.props;
    changeSortField({ field, resourceType });
  };

  render() {
    const { sort: { direction = '', field = this.props.sortFields[0] }, height, paddingTop, sortFields } = this.props;
    const styles = this.getStyle(height, paddingTop);
    return (
      <div style={styles.sortBlock}>
      <span style={{display: 'flex', alignItems: 'center'}}>
        <span style={{color: Colors.grey500, position: 'relative', top: 0}}>
          Sort:
        </span>
        <DropDownMenu
          style={{fontWeight: 500, marginRight: -37, MozTop: 0, top: 2, marginLeft: -15, fontSize: 14}}
          iconStyle={{fill: Colors.grey700, top: 0}}
          labelStyle={{textTransform: 'uppercase', height: height, lineHeight: `${height}px`}}
          value={field}
          onChange={this._changeSortField}
          underlineStyle={{display: 'none'}}
        >
          <Subheader style={{lineHeight: '32px'}}>Sort By:</Subheader>
          {
            _.map(sortFields, label => (
                <MenuItem
                  key={label}
                  value={label}
                  primaryText={_.capitalize(label)}
                  leftIcon={(label === field) ? <CheckIcon color={Colors.lightGreen700} /> : <CheckIcon style={{opacity: 0}}/>}
                />
              )
            )
          }
        </DropDownMenu>
        <IconButton iconStyle={direction === SORT_DIRECTION_ASC ? {transform: 'rotate(180deg)'} : {}} onClick={this._changeSortDirection}>
          <ArrowDownward />
        </IconButton>
      </span>
      </div>
    );
  }
}

SortBlock.defaultProps = {
  height: 48,
  sortFields: [],
};

SortBlock.propTypes = {
  height: PropTypes.number,
  sortFields: PropTypes.arrayOf(PropTypes.string),
};